import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { authApi, setToken } from "@/lib/api";
import { X, Lock } from "lucide-react";
import { toast } from "sonner";

export default function AdminLoginModal({ onClose }) {
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    if (!password) return;
    setSubmitting(true);
    try {
      const { access_token } = await authApi.login(password);
      setToken(access_token);
      toast.success("Welcome, admin");
      onClose();
      navigate("/admin");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Login failed");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div
      data-testid="admin-login-modal"
      className="fixed inset-0 bg-black/50 flex items-center justify-center p-4 z-50"
      onClick={onClose}
    >
      <div
        className="bg-white rounded-2xl w-full max-w-sm p-6 shadow-2xl"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between mb-4">
          <h3 className="font-heading text-xl font-bold text-[color:var(--rr-blue)] flex items-center gap-2">
            <Lock className="w-5 h-5" /> Admin login
          </h3>
          <button
            data-testid="close-login-btn"
            onClick={onClose}
            className="p-2 rounded-full hover:bg-slate-100"
            aria-label="Close"
          >
            <X className="w-5 h-5" />
          </button>
        </div>
        <form onSubmit={submit} className="grid gap-3">
          <input
            data-testid="login-password"
            type="password"
            autoFocus
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Password"
            className="w-full px-4 py-3 rounded-lg border border-slate-300 focus:border-[color:var(--rr-blue)] outline-none"
          />
          <button
            data-testid="login-submit-btn"
            type="submit"
            disabled={submitting}
            className="px-5 py-3 rounded-full bg-[color:var(--rr-blue)] text-white font-semibold hover:bg-[color:var(--rr-blue-dark)] transition disabled:opacity-60"
          >
            {submitting ? "Signing in..." : "Sign in"}
          </button>
        </form>
      </div>
    </div>
  );
}
